module.exports = __webpack_public_path__ + "media/images/emblems/Reiden_LU-7d4ac2682041d22cd95fa0a91b6c10d9.png";